import React from "react";

/**
 * Skeleton — placeholder de carga coherente con el layout final.
 * Alineado con Etapa 3 §9 (loading states) y Etapa 4 §2.13.
 */
export function Skeleton({ className = "", variant = "block", count = 1, testid = "skeleton" }) {
  const base = "animate-pulse bg-slate-200/70 rounded-md";
  const variants = {
    block: "h-4 w-full",
    text: "h-3 w-3/4",
    title: "h-6 w-1/2",
    avatar: "h-16 w-16 rounded-full",
    ring: "h-24 w-24 rounded-full",
    card: "h-32 w-full rounded-xl",
    input: "h-11 w-full rounded-lg",
  };
  const items = Array.from({ length: count });
  return (
    <div data-testid={testid} aria-hidden="true">
      {items.map((_, i) => (
        <div
          key={i}
          className={`${base} ${variants[variant] || variants.block} ${className} ${i > 0 ? "mt-2" : ""}`}
        />
      ))}
    </div>
  );
}

export default Skeleton;
